import React, { useCallback, useContext, useMemo, useState } from "react"
import { BSVariantFormDialog } from "./BSVariantFormDialog"
import { Children } from "../../../../../../components/miscellianous/children"
import { OrganizationContext } from "../../../../../../core/context/organization/organization-context"
import { MaxBeemShotDialog } from "../MaxBeemShotDialog"
import { isAvailableLicense } from "../../../../../../core/services/license-service"
import { BSVariantListContext } from "../../../../../../core/context/beem-shot/BSVariant/BSVariantListContext"

export const CreateVariantDialogContext = React.createContext<CreateVariantDialogStore>({} as CreateVariantDialogStore)

export function CreateVariantDialogContextProvider({ children }: Readonly<Children>): React.JSX.Element {
  const { organization } = useContext(OrganizationContext)

  const { bsVariants } = useContext(BSVariantListContext)
  const [openCreateVariantForm, setOpenCreateVariantForm] = useState<boolean>(false)
  const [openMaxBeemShotDialog, setOpenMaxBeemShotDialog] = useState<boolean>(false)

  const handleOpen: () => void = useCallback(() => {
    if (
      bsVariants.length === 0 &&
      !isAvailableLicense(organization?.maxProjectEstimationCount, organization?.projectEstimationCounter)
    ) {
      setOpenMaxBeemShotDialog(true)
    } else {
      setOpenCreateVariantForm(true)
    }
  }, [bsVariants, organization?.maxProjectEstimationCount, organization?.projectEstimationCounter])

  const handleCloseCreate: () => void = useCallback(() => {
    setOpenCreateVariantForm(false)
  }, [])

  const createVariantDialogStore = useMemo(() => ({ handleOpen, handleClose: handleCloseCreate }), [handleOpen])

  return (
    <CreateVariantDialogContext.Provider value={createVariantDialogStore}>
      <BSVariantFormDialog open={openCreateVariantForm} bsVariant={undefined} handleClose={handleCloseCreate} />
      <MaxBeemShotDialog open={openMaxBeemShotDialog} setOpen={setOpenMaxBeemShotDialog} />
      {children}
    </CreateVariantDialogContext.Provider>
  )
}

export interface CreateVariantDialogStore {
  handleOpen(): void
  handleClose(): void
}
